export function logAuditState(eventName: string, extra: Record<string, any> = {}) {
  if (typeof window === 'undefined') return;

  const bodyStyle = getComputedStyle(document.body);
  const htmlStyle = getComputedStyle(document.documentElement);

  const data = {
    event: eventName,
    timestamp: performance.now().toFixed(2),
    bodyScrollHeight: document.body.scrollHeight,
    htmlScrollHeight: document.documentElement.scrollHeight,
    windowInnerHeight: window.innerHeight,
    windowScrollY: window.scrollY,
    bodyOverflow: bodyStyle.overflow,
    htmlOverflow: htmlStyle.overflow,
    bodyPosition: bodyStyle.position,
    htmlPosition: htmlStyle.position,
    bodyTouchAction: bodyStyle.touchAction,
    htmlTouchAction: htmlStyle.touchAction,
    bodyOverscrollBehavior: bodyStyle.overscrollBehavior,
    htmlOverscrollBehavior: htmlStyle.overscrollBehavior,
    ...extra,
  };

  if (import.meta.env.DEV) {
    console.log(`[AUDIT_LOG] ${eventName}`, data);
  }
}

if (typeof window !== 'undefined') {
  if (document.readyState === 'loading') {
    window.addEventListener('DOMContentLoaded', () => {
      logAuditState('1. DOMContentLoaded');
    });
  } else {
    logAuditState('1. DOMContentLoaded (Already Fired)');
  }
}
